import { InjectionToken } from '@angular/core';

export interface ObservabilityError {
  readonly source: string;
  readonly message: string;
  readonly status?: number;
}

export interface ObservabilityTiming {
  readonly name: string;
  readonly durationMs: number;
  readonly ok: boolean;
}

export interface ObservabilitySink {
  error(event: ObservabilityError): void;
  timing(event: ObservabilityTiming): void;
}

export const OBSERVABILITY_SINK = new InjectionToken<ObservabilitySink>('OBSERVABILITY_SINK', {
  providedIn: 'root',
  factory: () => ({ error: () => undefined, timing: () => undefined }),
});
